import React from 'react';

const ArrowLeftIcon = () => {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107L7.29289 14.435C7.68342 14.8256 8.31658 14.8256 8.70711 14.435C9.09763 14.0445 9.09763 13.4113 8.70711 13.0208L3.05025 7.36396L8.70711 1.70711C9.09763 1.31658 9.09763 0.683418 8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893Z"
        fill="#6E7C87"
      />
    </svg>
  );
};

export default ArrowLeftIcon;
